/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('sign.employee', ['sign.employee.registration']);
